import ApiService from "../api";

export default class ContasAPagarService extends ApiService {

    constructor() {
        super("/api/solicitacoes/contas-a-pagar");
    }

    listar() {
        return this.get("");
    }

    listarEmAbertoNoFortes(vencimentoInicial, vencimentoFinal) {
        return this.get(`/fortes-em-aberto?vencimentoInicial=${vencimentoInicial}&vencimentoFinal=${vencimentoFinal}`);
    }

    buscarLancamentoNoFortes(codigo) {
        return this.get(`/fortes-lancamento/${encodeURIComponent(codigo)}`);
    }

    /**
     * Busca lançamentos no contas a pagar do Fortes. Todos os filtros são opcionais e se somam: documento
     * (CNPJ/CPF), fornecedor (nome), vencimento inicial/final (parcelas) e nota fiscal.
     */
    buscarLancamentosNoFortes({ documento, fornecedor, vencimentoInicial, vencimentoFinal, notaFiscal, limite = 10 } = {}) {
        const params = new URLSearchParams();
        if (documento) params.append("documento", documento);
        if (fornecedor) params.append("fornecedor", fornecedor);
        if (vencimentoInicial) params.append("vencimentoInicial", vencimentoInicial);
        if (vencimentoFinal) params.append("vencimentoFinal", vencimentoFinal);
        if (notaFiscal) params.append("notaFiscal", notaFiscal);
        params.append("limite", limite);
        return this.get(`/fortes-fornecedor?${params.toString()}`);
    }

    /**
     * "Sincronizar com Fortes" da etapa de lançamento: lançamentos do Fortes que correspondem à solicitação
     * e, quando há um só confiável, o código sugerido. Não grava nada.
     */
    sincronizarCodigoLancamento(solicitacaoId) {
        return this.get(`/codigo-lancamento/${solicitacaoId}/sincronizar`);
    }

    finalizar(solicitacaoIds, comentario) {
        return this.post("/finalizar", { solicitacaoIds, comentario });
    }

    /** Analisa o extrato bancário (Excel) e devolve as solicitações sugeridas por débito. Não grava. */
    analisarExtrato(arquivo) {
        const form = new FormData();
        form.append("arquivo", arquivo);
        return this.post("/extrato/analisar", form, { headers: { "Content-Type": "multipart/form-data" } });
    }

    vincularExtrato(payload) {
        return this.post("/extrato/vincular", payload);
    }
}
